import type { DateValue } from '@heroui/react';
import type { ICellEditorParams } from 'ag-grid-community';
import type { ComponentProps } from 'react';

import { DatePicker } from '@heroui/react';
import { CalendarDate, getLocalTimeZone, parseDate } from '@internationalized/date';
import { I18nProvider } from '@react-aria/i18n';

import { formatToISOLocalDate } from '@org/utils';

interface DatePickerCellEditorProps extends ICellEditorParams {
  value: Date | null;
  onValueChange: (value: unknown) => void;
}

type PickerValue = ComponentProps<typeof DatePicker>['value'];
type NonNullPickerValue = Exclude<PickerValue, null | undefined>;

export const DatePickerCellEditor = (props: DatePickerCellEditorProps) => {
  const { value, onValueChange } = props;

  const handleChange = (newValue: DateValue | null) => {
    const newDate = newValue?.toDate(getLocalTimeZone()) ?? null;
    onValueChange(newDate);
  };

  return (
    <I18nProvider locale="de-DE">
      <DatePicker
        aria-label="DatePickerCellEditor"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        className="max-w-[284px]"
        classNames={{
          base: 'bg-white border-solid border-grey-light border-1',
          inputWrapper: 'bg-white hover:bg-grey-100',
        }}
        granularity="day"
        onChange={handleChange}
        placeholderValue={
          new CalendarDate(new Date().getFullYear(), 1, 1) as unknown as NonNullPickerValue
        }
        radius="none"
        value={
          value
            ? (parseDate(formatToISOLocalDate(value) ?? '') as unknown as NonNullPickerValue)
            : null
        }
        variant="flat"
      />
    </I18nProvider>
  );
};
